import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import { ActionInterface } from "../../Interface/ActionInterface";
import AttachmentFactory from "../../Entity/Factories/AttachmentFactory";

export default function* avatarSet(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_SET_AVATAR_REQUEST
    });

    yield call(Http.put, `avatarSet/${action.payload?.avatar.id}`);

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this);
    }

    if (action.payload?.entity) {
      const entity = action.payload?.entity.reinitialize({
        attachments: action.payload?.attachments.map(attachment => AttachmentFactory.create(attachment.data))
      });
      
      switch (action.payload?.relation) {
        case "contactId":
        case "companyId":
        case "propertyId":
        case "unitId":
        case "contractId":
          yield put({
            type: Constants.GLOBAL_SET_AVATAR_SUCCESS,
            payload: {
              isAgency: false,
              entity: entity
            }
          });
          break;

        case "agencyId":
          yield put({
            type: Constants.GLOBAL_SET_AVATAR_SUCCESS,
            payload: {
              isAgency: true,
              entity: entity
            }
          });
          break;

        default:
          return;
      }
    }

  } catch (err) {

    yield ErrorHandlerSequence(err, action);

    yield put({
      type: Constants.GLOBAL_SET_AVATAR_FAILURE,
      payload: {
        err: err
      }
    });
  }
}

export function* watchAvatarSet() {
  yield takeEvery(Constants.GLOBAL_SET_AVATAR_START, avatarSet);
}
